import React from 'react';
import { useMessageGetter, Message } from '@messageformat/react';
import { Alert } from '@op/opds.opux';
import { ErrorCode } from '../../constants';

const RepresentationAlert = ({ errorCode }) => {
    const msg = useMessageGetter('fp');

    const alertTitle = () => {
        return errorCode === ErrorCode.REPRESENTATIONS_HAS_ERROR ? 'fethRepresentationsError.title' : 'applicationError.title';
    };

    const errorBody = () => {
        return errorCode === ErrorCode.REPRESENTATIONS_HAS_ERROR ? 'fp.fethRepresentationsError.body' : 'fp.applicationError.body';
    };

    return (
        <div className='representation-alert-container'>
            <Alert type='critical' title={msg(alertTitle())}>
                <Message id={errorBody()} />
            </Alert>
        </div>
    );
};

export default RepresentationAlert;
